<template>
  <v-dialog @input="toggleModal()"
            max-width="1000px"
            :value="value">
    <v-card>
      <v-toolbar color="abadPrimary"
                 dark
                 dense
                 flat>
        <v-toolbar-title style="text-transform: capitalize">
          {{owner && owner.nombres ? owner.nombres.toLowerCase() : 'Dueño'}}
        </v-toolbar-title>

        <v-spacer/>

        <v-icon @click="toggleModal()">
          mdi-close
        </v-icon>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="owner">
          <v-col cols="12" sm="6" md="4" v-if="owner.nombres">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Nombres
            </div>

            <div>
              {{owner.nombres}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.nombres2">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Nombres 2
            </div>

            <div>
              {{owner.nombres2}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.cedula">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Cédula
            </div>

            <div>
              {{owner.cedula}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.celular">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Celular
            </div>

            <div>
              {{owner.celular}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.celular2">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Celular 2
            </div>

            <div>
              {{owner.celular2}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.email">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Email
            </div>

            <div>
              {{owner.email}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.fechaNacimiento">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Fecha de nacimiento
            </div>

            <div>
              {{owner.fechaNacimiento}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.fijo">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Fijo
            </div>

            <div>
              {{owner.fijo}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.fijo2">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Fijo 2
            </div>

            <div>
              {{owner.fijo2}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.perfil">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Perfil
            </div>

            <div>
              {{owner.perfil}}
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="owner.sexo">
            <div class="text-caption font-weight-bold abadPrimary--text">
              Sexo
            </div>

            <div>
              {{owner.sexo}}
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>

        <v-btn @click="toggleModal()"
               color="abadPrimary"
               text>
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: ['owner', 'value']
}
</script>
